const GROUP_VIEWER = 'GROUP_VIEWER';
const GROUP_MANAGER = 'GROUP_MANAGER';

export default {
  GROUP_VIEWER,
  GROUP_MANAGER,
};
